import restApi from '../http-common';
import CONFIG_COMPANY from "./myConfig";

export default class AdminApi {
    signIn(model) {
        return restApi({
            method: 'post',
            url: '/authentication/sign-in',
            data: {
                username: model.email,
                password: model.password,
                company: CONFIG_COMPANY.NAME
            }
        });
    }

    acceptTerms() {
        return restApi({
            method: 'put',
            url: '/users/accept-terms',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        });
    }

    changePassword(model) {
        return restApi({
            method: 'post',
            url: '/',
            data: {
                password: model.password,
            },
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        });
    }

    getUsers(model) {
        return restApi({
            method: 'get',
            url: '/users',
            params: {
                page: model.page,
                limit: model.limit,
                debtor: model.debtor,
                filter: model.filter,
                gender: model.gender,
                expireInDays: model.expireInDays,
                paymentsInRow: model.paymentsInRow,
                expireFromMonths: model.expireFromMonths,
                customCategory: model.customCategory,
                partnerCompany: model.partnerCompany,
                sortBy: model.sortBy,
                sortDirection: model.sortDirection,
                waitingListStatus: model.waitingListStatus,
            },
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    verifyUser(id) {
        return restApi({
            method: 'get',
            url: 'user/verify/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteUser(id) {
        return restApi({
            method: 'delete',
            url: '/users/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    registerUser(model) {
        return restApi({
            method: 'post',
            url: '/users',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getUsersByIds(model) {
        return restApi({
            method: 'post',
            url: '/users-by-ids',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getUser(id) {
        return restApi({
            method: 'get',
            url: '/users/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    adminAdjustUserBalance(model) {
        return restApi({
            method: 'post',
            url: '/user-balance/admin-adjust',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getUserBalanceHistory(userId, page, limit) {
        return restApi({
            method: 'get',
            url: '/user-balance/history',
            params: {
                userId: userId,
                page: page,
                limit: limit
            },
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getUsersWithNonZeroBalance(filter) {
        return restApi({
            method: 'get',
            url: '/user-balance/non-zero-users',
            params: {
                filter: filter
            },
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getUserAdditionalInfo(id) {
        return restApi({
            method: 'get',
            url: '/users/' + id + '/additional-info',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateUser(model, id) {
        return restApi({
            method: 'put',
            url: '/admin/users/' + id,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getPaymentByDate(model) {
        return restApi({
            method: 'get',
            url: '/payment',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate

            }
        })
    }

    getPayment(id) {
        return restApi({
            method: 'get',
            url: '/payment/user/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getMyPayment() {
        return restApi({
            method: 'get',
            url: '/payment/user',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    getPaymentById(id) {
        return restApi({
            method: 'get',
            url: '/payment/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addPayment(model) {
        return restApi({
            method: 'post',
            url: '/payment',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getAdditionalKit() {
        return restApi({
            method: 'get',
            url: '/companies/additionalKits',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateAdditionalKit(model) {
        return restApi({
            method: 'put',
            url: '/companies/additionalKits',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    getMemberships() {
        return restApi({
            method: 'get',
            url: '/membership-package',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getMembershipsCategories() {
        return restApi({
            method: 'get',
            url: '/membership-package/categories',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateMembershipsCategories(model) {
        return restApi({
            method: 'put',
            url: '/membership-package/categories',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    addMembershipsPackage(model) {
        return restApi({
            method: 'post',
            url: '/membership-package',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    buyMembershipsPackage(packageId, date) {
        return restApi({
            method: 'get',
            url: '/payment/user/extend-from-package/' + packageId + '?fromDate=' + date,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteMembership(id) {
        return restApi({
            method: 'delete',
            url: '/membership-package/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateMembership(model, id) {
        return restApi({
            method: 'put',
            url: '/membership-package',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getMembershipById(id) {
        return restApi({
            method: 'get',
            url: '/membership-package/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateCompanyTrainingTypes(model) {
        return restApi({
            method: 'put',
            url: '/companies/trainingTypes',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    getCompanyTrainingTypes() {
        return restApi({
            method: 'get',
            url: '/companies/trainingTypes',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    updatePayment(model, id) {
        return restApi({
            method: 'put',
            url: '/payment/' + id,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deletePayment(id) {
        return restApi({
            method: 'delete',
            url: '/payment/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getProfile() {
        return restApi({
            method: 'get',
            url: '/users/me',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateProfile(model) {
        return restApi({
            method: 'put',
            url: '/users',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    extendPayment(model) {
        return restApi({
            method: 'get',
            url: '/payment/user/extend',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    extendPaymentFromAdmin(userId) {
        return restApi({
            method: 'get',
            url: '/payment/admin/extend?userId=' + userId,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTerms() {
        return restApi({
            method: 'get',
            url: '/terms',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addTerm(model) {
        return restApi({
            method: 'post',
            url: '/terms',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addTerms(model) {
        return restApi({
            method: 'post',
            url: '/terms-with-times',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteTerm(id) {
        return restApi({
            method: 'delete',
            url: '/terms/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteTerms(ids) {
        return restApi({
            method: 'delete',
            url: '/delete-terms',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                ids: ids
            }
        })
    }

    getTermsById(id) {
        return restApi({
            method: 'get',
            url: '/terms/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateTerm(model, id) {
        return restApi({
            method: 'put',
            url: '/terms/' + id,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getSlotByDate(date) {
        return restApi({
            method: 'get',
            url: '/slots',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                date: date
            }
        })
    }

    addSlot(model) {
        return restApi({
            method: 'post',
            url: '/slots',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteSlot(id) {
        return restApi({
            method: 'delete',
            url: '/slots/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteSlotAndUsers(id, shouldRevertTraining) {
        return restApi({
            method: 'delete',
            url: '/slots-and-users/' + id + '?shouldRevertTraining=' + shouldRevertTraining,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deactivatedSlot(id) {
        return restApi({
            method: 'delete',
            url: '/deactivate/slots/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    activateDeactivateSlots(model) {
        return restApi({
            method: 'put',
            url: '/activate/slots',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    activatedSlot(id) {
        return restApi({
            method: 'put',
            url: '/activate/slots/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getSlotById(id) {
        return restApi({
            method: 'get',
            url: '/slots/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateSlot(model, id) {
        return restApi({
            method: 'put',
            url: '/slots/' + id,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addTraining(model) {
        return restApi({
            method: 'post',
            url: '/training',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addQrCodeTraining(model) {
        return restApi({
            method: 'post',
            url: '/training-qr',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addTrainingFromAdmin(model, userId) {
        return restApi({
            method: 'post',
            url: '/training/reserve-admin?userId=' + userId,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    adminSignUpUserForTrainingAsScanQrCode(model, userId) {
        return restApi({
            method: 'post',
            url: '/training-admin-add-user-scan-qr-in-gym?userId=' + userId,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteTraining(id) {
        return restApi({
            method: 'delete',
            url: '/training/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteTrainingAndRevertToUser(id) {
        return restApi({
            method: 'delete',
            url: 'revert/training/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTrainingsByDate(date) {
        return restApi({
            method: 'get',
            url: '/training',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                date: date
            }
        })
    }

    getMyTrainings() {
        return restApi({
            method: 'get',
            url: '/training/my',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTrainingTypes() {
        return restApi({
            method: 'get',
            url: '/training/types',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTrainingTypesColored() {
        return restApi({
            method: 'get',
            url: '/training/types-colored',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTrainingsReport(model, paymentCompany) {
        return restApi({
            method: 'get',
            url: '/admin/training',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                page: model.page,
                limit: model.limit,
                paymentCompany: paymentCompany,
                filter: model.filter,
                slotFilter: model.slotFilter
            }
        })
    }

    getTrainingReservationSummary(model) {
        return restApi({
            method: 'get',
            url: '/admin/training/report/reservation-summary',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate
            }
        })
    }

    getTrainerReport(model) {
        return restApi({
            method: 'get',
            url: '/slots/report/trainer-by-type',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                filter: model.filter,
            }
        })
    }

    getTrainerReportByUser(model) {
        return restApi({
            method: 'get',
            url: '/training/report/trainer-by-user',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                filter: model.filter,
            }
        })
    }

    getCalculatePriceForReport(model) {
        return restApi({
            method: 'get',
            url: '/admin/training/calculate-price',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                paymentCompany: model.paymentCompany,
                filter: model.filter
            }
        })
    }

    getTrainingsReportByPaymentCompany(model) {
        return restApi({
            method: 'get',
            url: '/admin/training/payment/company',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                paymentCompany: model.paymentCompany,
                filter: model.filter
            }
        })
    }

    getTrainingsReportByPartnerCompany(model) {
        return restApi({
            method: 'get',
            url: '/admin/training/payment/company-partner',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                partnerCompany: model.partnerCompany,
                filter: model.filter
            }
        })
    }

    getSlotReport(model) {
        return restApi({
            method: 'get',
            url: '/slots/report',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                filter: model.filter
            }
        })
    }

    getSlotReportCount(model) {
        return restApi({
            method: 'get',
            url: '/slots/count-report',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                filter: model.filter
            }
        })
    }

    getNotification(model) {
        return restApi({
            method: 'get',
            url: '/notifications',
            params: {
                company: model
            }
        })
    }

    getNotificationById(id) {
        return restApi({
            method: 'get',
            url: '/notifications/' + id,
        })
    }

    deleteNotifications(id) {
        return restApi({
            method: 'delete',
            url: '/notifications/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addNotification(model) {
        return restApi({
            method: 'post',
            url: '/notifications',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    editNotification(model) {
        return restApi({
            method: 'put',
            url: '/notifications',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    resetPassword(model) {
        return restApi({
            method: 'patch',
            url: '/users/password',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    resetUserPassword(id) {
        return restApi({
            method: 'patch',
            url: '/users/' + id + '/reset-password',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    openSlots(model) {
        return restApi({
            method: 'post',
            url: '/open/slots',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    plusTraining(id) {
        return restApi({
            method: 'put',
            url: '/training/plus/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    setTrainingNumber(id, number) {
        return restApi({
            method: 'put',
            url: '/training/set-number/' + id + '?numberOfTrainings=' + number,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    setAdditionalServices(id, number) {
        return restApi({
            method: 'put',
            url: '/training/set-additional-services/' + id + '?numberOfTrainings=' + number,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    minusTraining(id) {
        return restApi({
            method: 'put',
            url: '/training/minus/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addKey(model) {
        return restApi({
            method: 'put',
            url: '/training/key',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addNotArrival(userId) {
        return restApi({
            method: 'post',
            url: '/user/' + userId + '/add-not-arrival',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    removeNotArrival(userId) {
        return restApi({
            method: 'post',
            url: '/user/' + userId + '/remove-not-arrival',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateTrainingTypes(model, userId) {
        return restApi({
            method: 'put',
            url: '/user/' + userId + '/training-types',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCompanies(deleted) {
        return restApi({
            method: 'get',
            url: '/companies?deleted=' + deleted,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteCompanies(id) {
        return restApi({
            method: 'delete',
            url: '/companies/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    unarchiveCompany(id) {
        return restApi({
            method: 'patch',
            url: '/companies/unarchive/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCompanyApiKey(id) {
        return restApi({
            method: 'get',
            url: '/company-apy-key/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateVersions(model) {
        return restApi({
            method: 'post',
            url: '/versions',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCompany(id) {
        return restApi({
            method: 'get',
            url: '/companies/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCompanyConfiguration(company) {
        return restApi({
            method: 'get',
            url: '/configuration?company=' + company,
        })
    }

    getCompanyList(company) {
        return restApi({
            method: 'get',
            url: '/companies-list?company=' + company,
        })
    }

    getDoorCompanyConfiguration(company, location) {
        return restApi({
            method: 'get',
            url: '/door-config?company=' + company + '&location=' + location,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    updateDoorConfiguration(model, id) {
        return restApi({
            method: 'put',
            url: '/door-config',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addNewCompany(model) {
        return restApi({
            method: 'post',
            url: '/companies',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateCompany(model, id) {
        return restApi({
            method: 'put',
            url: '/companies/' + id,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateConfiguration(model, id) {
        return restApi({
            method: 'put',
            url: '/configuration',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCurrentVersion(company) {
        return restApi({
            method: 'get',
            url: '/version/current?company=' + company,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateVersion(model) {
        return restApi({
            method: 'post',
            url: '/version',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateReviewVersion(model) {
        return restApi({
            method: 'post',
            url: '/versions/review',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    getCompanyPayments() {
        return restApi({
            method: 'get',
            url: '/company-payment',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateCompanyPayments(model) {
        return restApi({
            method: 'put',
            url: '/company-payment',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addCompanyPayments(model) {
        return restApi({
            method: 'post',
            url: '/company-payment',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteCompanyPayments(id) {
        return restApi({
            method: 'delete',
            url: '/company-payment/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    subscribeToSlot(model) {
        return restApi({
            method: 'post',
            url: '/slots/subscribe',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    unsubscribeToSlot(model) {
        return restApi({
            method: 'post',
            url: '/slots/unsubscribe',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    approveTraining(model) {
        return restApi({
            method: 'post',
            url: '/training/checked',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateSubscribersToSlot(model) {
        return restApi({
            method: 'post',
            url: '/slots/update-subscribers',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    uploadImage(userId, file) {
        let formData = new FormData();
        formData.append("file", file);
        return restApi({
            method: 'patch',
            url: '/users/profile-image/' + userId,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'multipart/form-data',
            },
            data: formData
        });
    }


    getBusyProgress() {
        return restApi({
            method: 'get',
            url: '/training/busy-in-gym',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getInvoices(company) {
        return restApi({
            method: 'get',
            url: '/invoice?company=' + company,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getInvoicesCurrentBalance(company) {
        return restApi({
            method: 'get',
            url: '/invoice/current-balance?company=' + company,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getMinusInvoiceReport(fromDate, toDate) {
        return restApi({
            method: 'get',
            url: '/invoice/report/traffic',
            params: {
                fromDate: fromDate,
                toDate: toDate
            },
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    createAllInvoiceOrForCompany(company) {
        let params = company == null ? '' : '?companyName=' + company;
        return restApi({
            method: 'get',
            url: '/invoice-create-all' + params,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    deleteInvoice(id) {
        return restApi({
            method: 'delete',
            url: '/invoice/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addInvoice(model) {
        return restApi({
            method: 'post',
            url: '/invoice',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    setPaidInvoice(model) {
        return restApi({
            method: 'put',
            url: '/invoice/paid?payLastInvoice=' + model.payLastInvoice,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getAllForHomePage(model) {
        return restApi({
            method: 'get',
            url: '/company-info-home-page',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCompanyInfoById(id) {
        return restApi({
            method: 'get',
            url: '/company-info/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCompanyInfoShopItems() {
        return restApi({
            method: 'get',
            url: '/company-info-shop',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getShopInventoryItems(params) {
        return restApi({
            method: 'get',
            url: '/shop-inventory-item',
            params: params,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    saveShopInventoryItems(model) {
        return restApi({
            method: 'post',
            url: '/shop-inventory-item',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCashRegister(location) {
        return restApi({
            method: 'get',
            url: '/shop/cash-register',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                location: location
            }
        })
    }

    uploadImageCompanyInfo(file) {
        let formData = new FormData();
        formData.append("file", file);
        return restApi({
            method: 'patch',
            url: '/company-info/image',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'multipart/form-data',
            },
            data: formData
        });
    }


    addCompanyInfoTraining(model) {
        return restApi({
            method: 'post',
            url: '/company-info',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateCompanyInfoTraining(model) {
        return restApi({
            method: 'put',
            url: '/company-info',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteCompanyInfo(id) {
        return restApi({
            method: 'delete',
            url: 'company-info/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    hideCompanyInfo(id) {
        return restApi({
            method: 'get',
            url: 'company-info-hide/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    //ARTICLES

    getArticles(model) {
        return restApi({
            method: 'get',
            url: '/article',
            params: {
                page: model.page,
                limit: model.limit,
                filter: model.filter,
                sort: model.sort,
                internalCode: model.internalCode,
                state: model.state,
                mainCategory: model.mainCategory,
                subCategory: model.subCategory,
                fromDate: model.fromDate,
                toDate: model.toDate,
                fromInventoryDate: model.fromInventoryDate,
                toInventoryDate: model.toInventoryDate,
                isNewArticle: model.isNewArticle,
                kpPosted: model.kpPosted,
                addInfoMemory: model.addInfoMemory,
                ramMemory: model.ramMemory,
                color: model.color,
            },
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getArticlesReport(model) {
        return restApi({
            method: 'get',
            url: '/article-report',
            params: {
                filter: model.filter,
                internalCode: model.internalCode,
                state: model.state,
                mainCategory: model.mainCategory,
                subCategory: model.subCategory,
                fromDate: model.fromDate,
                toDate: model.toDate,
            },
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getArticleLogReport(model) {
        return restApi({
            method: 'get',
            url: '/article-log/report',
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
            },
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCScheduleReport(model) {
        return restApi({
            method: 'get',
            url: '/c-schedule/report',
            params: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getArticleById(id) {
        return restApi({
            method: 'get',
            url: '/article/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addArticle(model) {
        return restApi({
            method: 'post',
            url: '/article',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
    }

    updateArticle(model) {
        return restApi({
            method: 'put',
            url: '/article',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
    }

    updateArticleStock(model) {
        return restApi({
            method: 'put',
            url: '/article-stock',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    approveArticleStock(model) {
        return restApi({
            method: 'put',
            url: '/article-approve',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteArticle(id) {
        return restApi({
            method: 'delete',
            url: '/article/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    recoveryArticle(id) {
        return restApi({
            method: 'get',
            url: '/article-recovery/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateArticleInventory(model) {
        return restApi({
            method: 'put',
            url: '/article-inventory',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    addArticleCategory(model) {
        return restApi({
            method: 'post',
            url: '/article-category',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateArticleCategory(model) {
        return restApi({
            method: 'put',
            url: '/article-category',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateArticleCategoryColor(model) {
        return restApi({
            method: 'put',
            url: '/article-category-colors',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getArticleCategories() {
        return restApi({
            method: 'get',
            url: '/article-category',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteArticleCategory(id) {
        return restApi({
            method: 'delete',
            url: '/article-category/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteArticleColorFromCategory(model) {
        return restApi({
            method: 'delete',
            url: '/article-category-color',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateAppHeaderImage(model) {
        return restApi({
            method: 'put',
            url: '/company-info-header-image',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getAppHeaderByLocation() {
        return restApi({
            method: 'get',
            url: '/company-info-header-image-by-loaction',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getEntrances(model) {
        return restApi({
            method: 'get',
            url: '/admin/entrance',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                page: model.page,
                limit: model.limit,
                filter: model.filter
            }
        })
    }

    getEntranceReportSummary(model) {
        return restApi({
            method: 'get',
            url: '/admin/entrance/report/summary',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate
            }
        })
    }

    getUsersSummaryReport(model) {
        return restApi({
            method: 'get',
            url: '/admin/users/report/summary',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate
            }
        })
    }

    openDoorEntrance(location) {
        return restApi({
            method: 'get',
            url: '/admin/entrance/open?location=' + location,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    openDoorEntranceRemote(location) {
        return restApi({
            method: 'get',
            url: '/admin/entrance/open-remote?location='+location,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    resetDoorEntranceRemote() {
        return restApi({
            method: 'get',
            url: '/admin/entrance/reset-remote',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    //order

    buyProduct(uuid) {
        return restApi({
            method: 'get',
            url: '/order/buy/' + uuid,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },

        })
    }

    scanAndTakePaidOrder(uuid) {
        return restApi({
            method: 'get',
            url: '/order/scan-taken-paid/' + uuid,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },

        })
    }

    orderProduct(uuid) {
        return restApi({
            method: 'get',
            url: '/order/make/' + uuid,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },

        })
    }

    getAdminOrders(model) {
        return restApi({
            method: 'get',
            url: '/order-admin',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                page: model.page,
                limit: model.limit,
                filter: model.filter
            }
        })
    }

    getBills(model) {
        return restApi({
            method: 'get',
            url: '/shop/bills',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                page: model.page,
                limit: model.limit,
                filter: model.filter,
                location: model.location,
                category: model.category,
                paidWithCredit: model.paidWithCredit,
                notPaid: model.notPaid
            }
        })
    }

    getBudgetByCategory(model) {
        return restApi({
            method: 'get',
            url: '/shop/current-budget-by-category',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                location: model.location,
                category: model.category,
                paidWithCredit: model.paidWithCredit,
                notPaid: model.notPaid
            }
        })
    }

    getBillItems(id) {
        return restApi({
            method: 'get',
            url: '/shop/bills/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    cancelBill(id) {
        return restApi({
            method: 'delete',
            url: '/shop/cancel-bill/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    payBill(id) {
        return restApi({
            method: 'get',
            url: '/shop/pay-bill/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    deleteOrder(id) {
        return restApi({
            method: 'delete',
            url: '/order/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },

        })
    }

    setPaidUserWallet(id, value) {
        return restApi({
            method: 'patch',
            url: '/user-wallet/' + id + '/paid?paid=' + value,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },

        })
    }

    getAdminOrdersReservation(model) {
        return restApi({
            method: 'get',
            url: '/order-reservation-admin',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                page: model.page,
                limit: model.limit,
                filter: model.filter
            }
        })
    }

    makeOrderReservation(model) {
        return restApi({
            method: 'post',
            url: '/order-reservation',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteOrderReservation(id) {
        return restApi({
            method: 'delete',
            url: '/order-reservation/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    getAdminUserWallets(model) {
        return restApi({
            method: 'get',
            url: '/user-wallet-admin',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                page: model.page,
                limit: model.limit,
                filter: model.filter
            }
        })
    }

    //PERSONAL TRAININGS AND WOD

    addNewTrainingOfTheDay(model) {
        return restApi({
            method: 'post',
            url: '/training-of-the-day',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addNewTrainingDefinition(model) {
        return restApi({
            method: 'post',
            url: '/training-definition',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    editTrainingOfTheDay(model) {
        return restApi({
            method: 'put',
            url: '/training-of-the-day',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    editTrainingDefinition(model) {
        return restApi({
            method: 'put',
            url: '/training-definition',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    copyTrainingOfTheDayForDates(model) {
        return restApi({
            method: 'put',
            url: 'training-of-the-day/copy-days',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTrainingOfTheDayForPeriod(model) {
        return restApi({
            method: 'get',
            url: '/admin-training-of-the-day',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                type: model.type,
                programId: model.programId
            }
        })
    }

    getUserTrainingOfTheDayForPeriod(model) {
        return restApi({
            method: 'get',
            url: '/user-training-of-the-day',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                type: model.type,
                programId: model.programId,
                allTrainings: model.allTrainings
            }
        })
    }

    deleteTrainingOfTheDay(id) {
        return restApi({
            method: 'delete',
            url: '/training-of-the-day/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateTrainingOfTheDayOrderNumbers(data) {
        return restApi({
            method: 'put',
            url: '/training-of-the-day/order-number',
            data: data,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteTrainingDefinition(id) {
        return restApi({
            method: 'delete',
            url: '/training-definition/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTrainingDefinitions(model) {
        return restApi({
            method: 'get',
            url: '/training-definition',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                page: model.page,
                limit: model.limit,
                type: model.type,
                filter: model.filter,
            }
        })
    }


    uploadImageTrainingDefinition(file) {
        let formData = new FormData();
        formData.append("file", file);
        return restApi({
            method: 'patch',
            url: '/training-definition/image',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'multipart/form-data',
            },
            data: formData
        });
    }

    uploadImageTrainingOfTheDay(file) {
        let formData = new FormData();
        formData.append("file", file);
        return restApi({
            method: 'patch',
            url: '/training-of-the-day/image',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'multipart/form-data',
            },
            data: formData
        });
    }

    addPersonalProgram(model) {
        return restApi({
            method: 'post',
            url: '/personal-program',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    editPersonalProgram(model) {
        return restApi({
            method: 'put',
            url: '/personal-program',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    copyPersonalProgram(model) {
        return restApi({
            method: 'put',
            url: '/personal-program/copy',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getPersonalPrograms(model) {
        return restApi({
            method: 'get',
            url: '/personal-program',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                type: model.type,
                active: model.active,
                isTemplate: model.isTemplate,
                page: model.page,
                limit: model.limit,
                filter: model.filter,
            }
        })
    }

    getPersonalProgramById(id, withDetails) {
        return restApi({
            method: 'get',
            url: '/personal-program/' + id + '?withDetails=' + withDetails,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getPersonalProgramsUser(model) {
        return restApi({
            method: 'get',
            url: '/personal-program-user',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                type: model.type,
                active: model.active
            }
        })
    }

    getPersonalProgramsResults(id, userId) {
        return restApi({
            method: 'get',
            url: '/training-result-personal',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                programId: id,
                userId: userId,
            }
        })
    }

    getMyPersonalProgramsUser() {
        return restApi({
            method: 'get',
            url: '/my-personal-program-user',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }


    deletePersonalProgram(id) {
        return restApi({
            method: 'delete',
            url: '/personal-program/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addTrainingDefinitionTypeCategory(model) {
        return restApi({
            method: 'post',
            url: '/training-definition-type',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTrainingDefinitionTypeCategory(type) {
        return restApi({
            method: 'get',
            url: '/training-definition-type',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                type: type,
            }
        })
    }

    deleteTrainingDefinitionTypeCategory(id) {
        return restApi({
            method: 'delete',
            url: '/training-definition-type/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    getCompanyPartners() {
        return restApi({
            method: 'get',
            url: '/company-partner',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addCompanyPartner(model) {
        return restApi({
            method: 'post',
            url: '/company-partner',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateCompanyPartner(model) {
        return restApi({
            method: 'put',
            url: '/company-partner',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteCompanyPartner(id) {
        return restApi({
            method: 'delete',
            url: '/company-partner/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addUserCredit(model) {
        return restApi({
            method: 'post',
            url: '/user-credit',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    useUserCredit(model) {
        return restApi({
            method: 'post',
            url: '/user-credit/use',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteUserCredit(id) {
        return restApi({
            method: 'delete',
            url: '/user-credit/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getUserCredits(userId, active, used) {
        return restApi({
            method: 'get',
            url: '/user-credit/admin-view/' + userId + '?active=' + active + '&isUsed=' + used,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    uploadTrainingImageResult(file) {
        let formData = new FormData();
        formData.append("file", file);
        return restApi({
            method: 'patch',
            url: '/training-result/image',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'multipart/form-data',
            },
            data: formData
        });
    }

    getTrainingResultsForTrainingOfTheDays(ids) {
        const queryIds = ids.join(',');
        return restApi({
            method: 'get',
            url: '/training-result?ids=' + queryIds,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    getTrainingResultsForTrainingOfTheDaysWod(ids, gender) {
        const queryIds = ids.join(',');
        const genderQuery = gender == null ? '' : '&gender=' + gender;
        return restApi({
            method: 'get',
            url: '/training-result-wod?ids=' + queryIds + genderQuery,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    saveTrainingResultsForTrainingOfTheDays(model) {
        return restApi({
            method: 'post',
            url: '/training-results',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTranslations(company) {
        return restApi({
            method: 'get',
            url: '/translation/' + company,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addTranslations(model) {
        return restApi({
            method: 'post',
            url: '/translation',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateTranslations(model) {
        return restApi({
            method: 'put',
            url: '/translation',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteTranslations(model) {
        return restApi({
            method: 'put',
            url: '/translation-delete',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    uploadCompanyLogoImage(companyName, file) {
        let formData = new FormData();
        formData.append("file", file);
        return restApi({
            method: 'patch',
            url: '/companies/logo-image/' + companyName,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'multipart/form-data',
            },
            data: formData
        });
    }

    signUpForEvent(model) {
        return restApi({
            method: 'post',
            url: '/event-item',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateSignUpForEvent(model) {
        return restApi({
            method: 'put',
            url: '/event-item',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getEventDataForCompanyInfo(id) {
        return restApi({
            method: 'get',
            url: '/event-item/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getEventItems(model) {
        return restApi({
            method: 'get',
            url: '/event-item',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                companyInfoId: model.companyInfoId,
                page: model.page,
                limit: model.limit,
                filter: model.filter
            }
        })
    }

    addUserNotes(model) {
        return restApi({
            method: 'post',
            url: '/user-training-notes',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateUserNotes(model, id) {
        return restApi({
            method: 'put',
            url: '/user-training-notes/' + id,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getUserNotes(model) {
        return restApi({
            method: 'get',
            url: '/user-training-notes',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate
            }
        })
    }

    deleteUserNotes(id) {
        return restApi({
            method: 'delete',
            url: '/user-training-notes/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCurrentBudget() {
        return restApi({
            method: 'get',
            url: '/c-budget',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    updateBudget(model) {
        return restApi({
            method: 'put',
            url: '/c-budget',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getSchedules(params) {
        return restApi({
            method: 'get',
            url: '/c-schedule',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: params
        })
    }

    openSchedule(model) {
        return restApi({
            method: 'post',
            url: '/c-schedule/open',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    closeSchedule(model) {
        return restApi({
            method: 'post',
            url: '/c-schedule/close',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    changeArticleProfit(model) {
        return restApi({
            method: 'put',
            url: '/article-change-profit',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    additionalCostSchedule(model) {
        return restApi({
            method: 'post',
            url: '/c-schedule/additional-cost',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    editSchedule(model) {
        return restApi({
            method: 'put',
            url: 'c-schedule',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    editScheduleItem(model) {
        return restApi({
            method: 'put',
            url: 'c-schedule-item',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteSchedule(id) {
        return restApi({
            method: 'delete',
            url: '/c-schedule/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    approveSchedule(id, model) {
        return restApi({
            method: 'patch',
            url: '/c-schedule/lock/' + id,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    createCampaign(model) {
        return restApi({
            method: 'post',
            url: '/campaign',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    createCompanyCampaign(model) {
        return restApi({
            method: 'post',
            url: '/campaign-company',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCampaign() {
        return restApi({
            method: 'get',
            url: '/campaign',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    uploadProgramImage(file, companyName) {
        let formData = new FormData();
        formData.append("file", file);
        return restApi({
            method: 'patch',
            url: '/personal-program/image/' + companyName,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'multipart/form-data',
            },
            data: formData
        });
    }

    getTimedSlots(model) {
        return restApi({
            method: 'get',
            url: '/slot-timed',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                date: model.date,
            }
        })
    }

    createTimedSlots(model) {
        return restApi({
            method: 'post',
            url: '/slot-timed',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateTimedSlots(model) {
        return restApi({
            method: 'put',
            url: '/slot-timed',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteTimedSlot(id) {
        return restApi({
            method: 'delete',
            url: '/slot-timed/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    checkInSlot(model) {
        return restApi({
            method: 'post',
            url: '/slot-timed-session-in',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    slotCheckInWithUsername(model) {
        return restApi({
            method: 'post',
            url: '/slot-timed-session-in-username',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    checkOutSlot(model) {
        return restApi({
            method: 'post',
            url: '/slot-timed-session-out',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    extendSlotTimedSession(model) {
        return restApi({
            method: 'post',
            url: '/slot-timed-session-extend',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addShopItemToSession(model) {
        return restApi({
            method: 'post',
            url: '/slot-timed-session-additionals',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    copyTranslations(fromCompany, toCompany) {
        return restApi({
            method: 'post',
            url: '/translation-copy/' + fromCompany +'/' + toCompany,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    adminMakeBill(model) {
        return restApi({
            method: 'post',
            url: '/order/admin-make-bill',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getSubscriptions(state) {
        return restApi({
            method: 'get',
            url: '/subscriptions',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                state: state,
            }
        })
    }

    createBill(model) {
        return restApi({
            method: 'post',
            url: '/shop/create-bill',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    // Warehouse shop items
    getWarehouseShopItems(params) {
        return restApi({
            method: 'get',
            url: '/warehouse-shop-item',
            params: params,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getWarehouseShopItemById(id) {
        return restApi({
            method: 'get',
            url: '/warehouse-shop-item/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addWarehouseShopItem(model) {
        return restApi({
            method: 'post',
            url: '/warehouse-shop-item',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateWarehouseShopItem(model) {
        return restApi({
            method: 'put',
            url: '/warehouse-shop-item',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteWarehouseShopItem(id) {
        return restApi({
            method: 'delete',
            url: '/warehouse-shop-item/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    uploadArticleImage({ articleId, file, onProgress }) {
        let f = new FormData();
        f.append("file", file);

        return restApi({
            method: 'patch',
            url: '/articles-image/' + articleId,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'multipart/form-data',
            },
            data: f,
            onUploadProgress: (event) => {
                if (typeof onProgress === 'function' && event && event.total) {
                    onProgress(Math.round((event.loaded * 100) / event.total));
                }
            }
        });
    }

    setArticlePrimaryImage({ articleId, imageId }) {
        return restApi({
            method: 'patch',
            url: '/articles-image-primary/' + imageId + '/' + articleId,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    deleteArticleImage({ articleId, imageId, sessionId }) {
        return restApi({
            method: 'delete',
            url: '/articles-image/' + imageId,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        });
    }

    getArticleImages(articleId) {
        return restApi({
            method: 'get',
            url: '/articles-images/' + articleId,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    getArticleImageProxy(imageId) {
        return restApi({
            method: 'get',
            url: '/articles-image-proxy/' + imageId,
            responseType: 'blob',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    saveArticleImagesOrder(items) {
        return restApi({
            method: 'post',
            url: '/articles-image/order',
            data: items,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    getKpCategories() {
        return restApi({
            method: 'get',
            url: '/kp/categories',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    getKpGroups(categoryId) {
        return restApi({
            method: 'get',
            url: '/kp/categories/' + categoryId + '/groups',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    publishKpAd(articleId) {
        return restApi({
            method: 'post',
            url: '/kp/ad/' + articleId,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    updateKpAd(articleId) {
        return restApi({
            method: 'put',
            url: '/kp/ad/' + articleId,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    importKpAd(model) {
        return restApi({
            method: 'post',
            url: '/kp/ad/import',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    unlinkKpAd(articleId) {
        return restApi({
            method: 'post',
            url: '/kp/ad/' + articleId + '/unlink',
            data: null,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    parkKpAd(articleId) {
        return restApi({
            method: 'post',
            url: '/kp/ad/' + articleId + '/park',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    unparkKpAd(articleId) {
        return restApi({
            method: 'post',
            url: '/kp/ad/' + articleId + '/unpark',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    deleteKpAd(articleId) {
        return restApi({
            method: 'delete',
            url: '/kp/ad/' + articleId,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }

    getProfits(model) {
        return restApi({
            method: 'get',
            url: '/profits',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                from: model.fromDate,
                to: model.toDate,
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/services/api.js